import Vue from 'vue'
import moment from 'moment'
import numeral from 'numeral'

Vue.mixin({
  methods: {
    base_url () {
      var port = location.port
      if (port === '8080') {
        return window.location.origin
      } else {
        return window.location.origin + '/' + window.location.pathname.split('/')[1]
      }
    },
    format_date (str) {
      return moment(str).add(543, 'year').format('DD/MM/YYYY h:mm:ss a')
    },
    format_moment (str) {
      return moment(str).format('YYYY/MM/DD  h:mm:ss')
    },
    format_number (str) {
      return numeral(str).format('0,0.00')
    },
    format_money (str) {
      return numeral(str).format('0,0')
    },
    setUser () {
      if (sessionStorage.user === undefined) {
        this.$router.push('/admin/login')
      } else {
        this.$store.state.user = JSON.parse(sessionStorage.user)
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/services/mixin.js